import { useState, useRef, useLayoutEffect, MutableRefObject } from 'react';

export const useElementSize = (): [
  MutableRefObject<HTMLDivElement | null>,
  { width: number; height: number },
] => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const elementRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (!elementRef.current) {
      return () => {};
    }

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === elementRef.current) {
          const { width, height } = entry.contentRect;
          // Same size must return the same object, or every observer
          // notification re-renders and can feed back into a resize loop.
          setSize((prev) =>
            prev.width === width && prev.height === height
              ? prev
              : { width, height },
          );
        }
      }
    });

    observer.observe(elementRef.current);

    return () => {
      observer.disconnect();
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  return [elementRef, size];
};
